import _newArrowCheck from "@babel/runtime/helpers/newArrowCheck";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import Utils from './utils';
import Validator from './validator';
var Constraint = function Constraint(parsleyField, name, requirements, priority, isDomConstraint) {
  var validatorSpec = window.Parsley._validatorRegistry.validators[name];
  var validator = new Validator(validatorSpec);
  priority = priority || parsleyField.options[name + 'Priority'] || validator.priority;
  isDomConstraint = true === isDomConstraint;
  Object.assign(this, {
    validator: validator,
    name: name,
    requirements: requirements,
    priority: priority,
    isDomConstraint: isDomConstraint
  });
  this._parseRequirements(parsleyField.options);
};
var capitalize = function capitalize(str) {
  var cap = str[0].toUpperCase();
  return cap + str.slice(1);
};
Constraint.prototype = {
  validate: function validate(value, instance) {
    var _this$validator;
    return (_this$validator = this.validator).validate.apply(_this$validator, [value].concat(_toConsumableArray(this.requirementList), [instance]));
  },
  _parseRequirements: function _parseRequirements(options) {
    var _this = this;
    this.requirementList = this.validator.parseRequirements(this.requirements, function (key) {
      _newArrowCheck(this, _this);
      return options[this.name + capitalize(key)];
    }.bind(this));
  }
};
export default Constraint;